import { rankingItems } from '@/mocks/animeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            热度榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            全网漫友用脚投票的热度排行，看看大家都在追什么
          </p>
        </div>

        <div className="max-w-[700px] mx-auto">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 md:gap-5 p-4 md:p-5 rounded-xl hover:bg-background-100 transition-colors cursor-pointer group border-b border-background-200/50 last:border-0"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 rounded-xl bg-background-100 flex items-center justify-center flex-shrink-0">
                <span
                  className={`font-heading text-lg md:text-xl ${
                    item.rank === 1
                      ? 'text-accent-500'
                      : item.rank === 2
                        ? 'text-primary-500'
                        : item.rank === 3
                          ? 'text-secondary-500'
                          : 'text-foreground-400'
                  }`}
                >
                  {item.rank}
                </span>
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-medium text-sm md:text-base text-foreground-900 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>

              <div className="flex items-center gap-3 flex-shrink-0">
                <div className="text-right">
                  <div className="text-sm md:text-base font-heading text-foreground-800">
                    {item.hot}
                    <span className="text-xs text-foreground-400 font-body ml-0.5">热度</span>
                  </div>
                </div>
                <span
                  className={`inline-flex items-center gap-0.5 text-xs font-medium whitespace-nowrap ${
                    item.trend === 'up'
                      ? 'text-primary-500'
                      : item.trend === 'down'
                        ? 'text-secondary-500'
                        : 'text-accent-500'
                  }`}
                >
                  {item.trend === 'up' && <i className="ri-arrow-up-line"></i>}
                  {item.trend === 'down' && <i className="ri-arrow-down-line"></i>}
                  {item.trend === 'new' && <i className="ri-sparkling-line"></i>}
                  {item.change}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}